import { render } from "./WebSkillRankingTable.vue?vue&type=template&id=b61a50d4&scoped=true"
import script from "./WebSkillRankingTable.vue?vue&type=script&lang=js"
export * from "./WebSkillRankingTable.vue?vue&type=script&lang=js"

import "./WebSkillRankingTable.vue?vue&type=style&index=0&id=b61a50d4&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b61a50d4"]])

export default __exports__